export default __webpack_public_path__ + "static/bentoSectionBg5-32f3aa843d816d28b5940c891044169a.webp";